// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const MOTHERS_FIELD_ALIASES = {
  hospitalName: ['요양기관명'],
  drugCode: ['보험코드'],
  pharmaceuticalCompanyName: ['제조사'],
  drugName: ['제품명'],
  unitPrice: ['단가'],
  feeRate: ['수수료율'],
  quantity: ['수량'],
  prescriptionAmount: ['처방액'],
  settlementAmount: ['수수료 금액'],
  note: ['비고'],
  note2: ['비고2'],
  note3: ['비고3'],
};

const REQUIRED_HEADERS = [
  '처방월',
  '정산월',
  '처방/조제',
  '요양기관명',
  '사업자등록번호',
  '요양기관자체코드',
  '영업담당자',
  '보험코드',
  '제조사',
  '제품명',
  '구분',
  '단가',
  '수수료율',
  '수량',
  '처방액',
  '수수료 금액',
  '비고',
  '비고2',
  '비고3',
];

function isMothersProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const mothersPharmTemplate = {
  id: 'mothers-pharm',
  name: '마더스제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isMothersProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isMothersProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(MOTHERS_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const insuranceCode = cleanText(row[columnMap.drugCode]);
      if (!insuranceCode) {
        return;
      }

      const note = [
        row[columnMap.note],
        row[columnMap.note2],
        row[columnMap.note3],
      ]
        .map((value) => cleanText(value))
        .filter(Boolean)
        .join(' / ');

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: cleanText(
          row[columnMap.pharmaceuticalCompanyName],
        ),
        customerName: row[columnMap.hospitalName],
        drugCode: row[columnMap.drugCode],
        drugName: row[columnMap.drugName],
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '마더스제약',
      templateName: this.name,
    };
  },
};

export default mothersPharmTemplate;
